/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListOperations200ResponseItemsInnerPeriod } from './ListOperations200ResponseItemsInnerPeriod';
import {
    ListOperations200ResponseItemsInnerPeriodFromJSON,
    ListOperations200ResponseItemsInnerPeriodFromJSONTyped,
    ListOperations200ResponseItemsInnerPeriodToJSON,
    ListOperations200ResponseItemsInnerPeriodToJSONTyped,
} from './ListOperations200ResponseItemsInnerPeriod';

/**
 * 明細データ一覧のアイテム
 * @export
 * @interface ListDetails200ResponseItemsInner
 */
export interface ListDetails200ResponseItemsInner {
    /**
     * ID
     * @type {string}
     * @memberof ListDetails200ResponseItemsInner
     */
    id: string;
    /**
     * 対象サービス（service_category）
     * @type {number}
     * @memberof ListDetails200ResponseItemsInner
     */
    serviceCategory: ListDetails200ResponseItemsInnerServiceCategoryEnum | null;
    /**
     * 金額種別（enum。別サービスは表示/集計に利用可能）
     * @type {number}
     * @memberof ListDetails200ResponseItemsInner
     */
    moneyCategory: ListDetails200ResponseItemsInnerMoneyCategoryEnum;
    /**
     * 支払日
     * @type {Date}
     * @memberof ListDetails200ResponseItemsInner
     */
    paymentDate: Date;
    /**
     * 
     * @type {ListOperations200ResponseItemsInnerPeriod}
     * @memberof ListDetails200ResponseItemsInner
     */
    paymentPeriod: ListOperations200ResponseItemsInnerPeriod;
    /**
     * 合計金額
     * @type {number}
     * @memberof ListDetails200ResponseItemsInner
     */
    totalAmount: number;
}


/**
 * @export
 */
export const ListDetails200ResponseItemsInnerServiceCategoryEnum = {
    OVERSEAS_ROAMING: 0
} as const;
export type ListDetails200ResponseItemsInnerServiceCategoryEnum = typeof ListDetails200ResponseItemsInnerServiceCategoryEnum[keyof typeof ListDetails200ResponseItemsInnerServiceCategoryEnum];

/**
 * @export
 */
export const ListDetails200ResponseItemsInnerMoneyCategoryEnum = {
    OVERSEAS_APP_PLATFORM_SALES: 0,
    TIP: 1,
    CANCELLATION_FEE: 2,
    TAXIFARE: 3
} as const;
export type ListDetails200ResponseItemsInnerMoneyCategoryEnum = typeof ListDetails200ResponseItemsInnerMoneyCategoryEnum[keyof typeof ListDetails200ResponseItemsInnerMoneyCategoryEnum];


/**
 * Check if a given object implements the ListDetails200ResponseItemsInner interface.
 */
export function instanceOfListDetails200ResponseItemsInner(value: object): value is ListDetails200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('serviceCategory' in value) || value['serviceCategory'] === undefined) return false;
    if (!('moneyCategory' in value) || value['moneyCategory'] === undefined) return false;
    if (!('paymentDate' in value) || value['paymentDate'] === undefined) return false;
    if (!('paymentPeriod' in value) || value['paymentPeriod'] === undefined) return false;
    if (!('totalAmount' in value) || value['totalAmount'] === undefined) return false;
    return true;
}

export function ListDetails200ResponseItemsInnerFromJSON(json: any): ListDetails200ResponseItemsInner {
    return ListDetails200ResponseItemsInnerFromJSONTyped(json, false);
}

export function ListDetails200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDetails200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'serviceCategory': json['service_category'],
        'moneyCategory': json['money_category'],
        'paymentDate': (new Date(json['payment_date'])),
        'paymentPeriod': ListOperations200ResponseItemsInnerPeriodFromJSON(json['payment_period']),
        'totalAmount': json['total_amount'],
    };
}

export function ListDetails200ResponseItemsInnerToJSON(json: any): ListDetails200ResponseItemsInner {
    return ListDetails200ResponseItemsInnerToJSONTyped(json, false);
}

export function ListDetails200ResponseItemsInnerToJSONTyped(value?: ListDetails200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'service_category': value['serviceCategory'],
        'money_category': value['moneyCategory'],
        'payment_date': ((value['paymentDate']).toISOString().substring(0,10)),
        'payment_period': ListOperations200ResponseItemsInnerPeriodToJSON(value['paymentPeriod']),
        'total_amount': value['totalAmount'],
    };
}

